import { axiosInstance } from '@fides/fides-react-components';
import { AxiosError } from 'axios';
import { CreditTransferOrder } from '../models';
import { JsonObject } from '../types';
import { endpoints } from '../consts';

export const orderAction = (
  action: string,
  uniqueIds: CreditTransferOrder['uniqueId'] | CreditTransferOrder['uniqueId'][],
  code = ''
): Promise<void> => {
  const ids = Array.isArray(uniqueIds) ? uniqueIds : [uniqueIds];

  return axiosInstance
    .post(
      `${endpoints.orders}/${action}`,
      action === 'sign'
        ? {
            uuids: ids,
            securityCode: code,
          }
        : ids,
      { baseURL: endpoints.EFTApiUrl }
    )
    .then(() => Promise.resolve())
    .catch((error: AxiosError<JsonObject>) => Promise.reject(error));
};
